<template>
    <nav>
        <v-app-bar fixed color="blue darken-4 white--text" flat app>
            <v-app-bar-nav-icon color="blue lighten-4" @click="toggleMenu"></v-app-bar-nav-icon>

            <v-toolbar-title :class="classToolbarTitleText">{{FormAreaTitle}}</v-toolbar-title>
            <v-spacer></v-spacer>
            <div :class="classCrfTitleText">{{getCrfTitle}}</div>
        </v-app-bar>

        <v-navigation-drawer v-model="getMainMenuDrawerLocal" class="primary" app>
            <v-layout class="drawer-close-layout hidden-md-and-up" justify-end>
                <v-btn @click="closeMenu" color="white" fab>
                    <v-icon large color="success">mdi-close</v-icon>
                </v-btn>
            </v-layout>

            <v-list class="primary drawer-bottom-spacing" dark>
                <v-list-item to="/" active-class="success" router>
                    <v-list-item-action>
                        <v-icon>mdi-home</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>{{NavMenuTitle}}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <template v-for="(item, index) in getMenuItems">
                    <v-list-item v-if="item.showMenuItem" active-class="success" :to="item.to" router :key="index">
                        <v-list-item-action>
                            <v-badge v-if="item.formCompleteness != ''" class="mt-1" right color="teal">
                                <span class="caption text-center" slot="badge">{{item.formCompleteness}}</span>
                                <v-icon>{{item.iconPath}}</v-icon>
                            </v-badge>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>{{item.caption}}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </template>
            </v-list>
        </v-navigation-drawer>
    </nav>
</template>
<script>
    import { mapGetters, mapMutations } from "vuex";
    export default {
        data() {
            return {
                drawer: null,
            };
        },
        methods: {
            ...mapMutations(["setMainMenuDrawer"]),
            toggleMenu: function () {
                this.setMainMenuDrawer(!this.getMainMenuDrawer);
            },
            closeMenu: function () {
                this.setMainMenuDrawer(false);
            }
        },
        computed: {
            ...mapGetters(["getCrfTitle", "getMenuItems", "getMainMenuDrawer", "getFormAuthenticated"]),
            getMainMenuDrawerLocal: {
                get: function () {
                    return this.getMainMenuDrawer;
                },
                set: function (value) {
                    this.setMainMenuDrawer(value);
                }
            },
            classToolbarTitleText: function () {
                return {
                    "toolbar-title-text-md": this.$vuetify.breakpoint.mdAndUp,
                    "toolbar-title-text-sm": this.$vuetify.breakpoint.smAndDown
                };
            },
            classCrfTitleText: function () {
                return {
                    "crf-title-text-md": this.$vuetify.breakpoint.mdAndUp,
                    "crf-title-text-sm": this.$vuetify.breakpoint.smAndDown
                };
            },
            //Navbar.vue-UIPanelCaptions BEGIN
FormAreaTitle: function () {
  switch(this.getFormAuthenticated){
    default: return ``;
  }
},
NavMenuTitle: function () {
  switch(this.getFormAuthenticated){
    case 70: return `RESTORE: 3 Month Questionnaire`;
    case 80: return `RESTORE: 6 Month Questionnaire`;
    case 90: return `RESTORE: 12 Month Questionnaire`;
    case 100: return `RESTORE: Interview Consent Form`;
    default: return `RESTORE HOME`;
  }
},
//Navbar.vue-UIPanelCaptions END
        }
    };
</script>
<style>
    .drawer-close-layout.layout {
        padding-top: 10px;
        padding-right: 7px;
    }

    .drawer-bottom-spacing {
        padding-bottom: 80px !important;
    }

    .menu-item-active {
        /*color:#00CC99;*/
        background-color: #d8ffcc;
        /*opacity: 0.7;*/
    }

    .toolbar-title-text-md {
        font-size: 1.5rem !important;
        font-weight: 400;
        line-height: 2rem;
        letter-spacing: normal !important;
        font-family: "Roboto", sans-serif !important;
    }

    .toolbar-title-text-sm {
        font-size: 1rem !important;
        font-weight: 500;
        line-height: 1rem;
        letter-spacing: 0.0125em !important;
        font-family: "Roboto", sans-serif !important;
        padding-left: 0 !important;
        width: 100px;
    }

    .crf-title-text-md {
        font-size: 1rem !important;
        font-weight: 400;
        letter-spacing: 0.009375em !important;
        line-height: 1.75rem;
    }

    .crf-title-text-sm {
        font-size: 0.875rem !important;
        font-weight: 500;
        letter-spacing: 0.0071428571em !important;
        line-height: 1.375rem;
    }
</style>
